<template>
  <v-dialog v-model="showShareFileDialog" persistent width="30%" height="45%">
    <v-card>
      <v-card-title>
        文件分享
        <v-spacer></v-spacer>
        <p @click="hideDialog" style="cursor: pointer" class="iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="padding: 16px">
        <div style="height: 400px;display:flex;flex-direction: column;align-items: center;">
          <div>
            <p style="font-size: 20px;color: black;">打开共生地球APP扫码获取相关文件</p>
          </div>
          <div ref="fileQRCode" id="fileQRCode" style="height: 200px;width: 200px;background-color: grey;margin-top: 35px"></div>
          <div style="display: flex;margin-top: 62px">
            <div @click="downloadClick" class="btn">
              <p class="iconfontFamily">&#xe67e;</p>
              <p style="margin-left: 8px">保存二维码</p>
            </div>
            <div @click="copyShareLink" class="btn" style="margin-left: 26px;">
              <p class="iconfontFamily">&#xe68a;</p>
              <p style="margin-left: 8px">复制分享链接</p>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  name: 'ShareFileDialog',
  props: ['showShareFileDialog', 'shareLink', 'shareQRCode', 'fileId'],
  data() {
    return {}
  },
  methods: {
    hideDialog() {
      this.$emit('closeShareFileDialog')
    },
    createQRCode(url) {
      new QRCode(this.$refs.fileQRCode, {
        width: 200,
        height: 200,
        text: url,
        colorDark: '#000',
        colorLight: '#fff'
      })
    },
    downloadClick() {
      // 先找到canvas节点下的二维码图片
      const myCanvas = document.getElementById('fileQRCode').getElementsByTagName('canvas')
      const img = document.getElementById('fileQRCode').getElementsByTagName('img')

      // 创建一个a节点
      const a = document.createElement('a')
      // 设置a的href属性将canvas变成png格式
      const imgURL = myCanvas[0].toDataURL('image/jpg')
      const ua = navigator.userAgent
      if (ua.indexOf('Trident') !== -1 && ua.indexOf('Windows') !== -1) { // IE内核 并且  windows系统 情况下 才执行;
        var bstr = atob(imgURL.split(',')[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        const blob = new Blob([u8arr])
        window.navigator.msSaveOrOpenBlob(blob, '下载' + '.' + 'png')
      } else if (ua.indexOf('Firefox') > -1) { // 火狐兼容下载
        const blob = this.base64ToBlob(imgURL); //new Blob([content]);
        const evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        a.download = this.fileId + '分享二维码'; //下载图片名称，如果填内容识别不到，下载为未知文件，所以我这里就不填为空
        a.href = URL.createObjectURL(blob);
        a.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }));
      } else { // 谷歌兼容下载
        img.src = myCanvas[0].toDataURL('image/jpg')
        a.href = img.src
        // 设置下载文件的名字
        a.download = this.fileId + '分享二维码';
        // 点击
        a.click();
      }
    },

    // base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {
        type: contentType
      });
    },
    copyShareLink() {
      let context = JSON.parse(JSON.stringify(this.shareLink))
      if(window.clipboardData){
        window.clipboardData.setData('text',context)
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "链接复制成功"
        this.$store.state.snackbarType = 'success'
      }else if(document.execCommand('Copy')){
        (function () {
          document.oncopy = function (e) {
            e.clipboardData.setData('text',context)
            e.preventDefault()
            document.oncopy = null
          }
        })(context)
        document.execCommand('Copy')
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "链接复制成功"
        this.$store.state.snackbarType = 'success'
      }else{
        this.$store.state.snackbarShow = true
        this.$store.state.snackbarText = "链接复制失败"
        this.$store.state.snackbarType = 'error'
      }
    },
  },
  mounted() {
    this.createQRCode(this.shareQRCode)
  }
}
</script>

<style scoped>
.btn {
  width: 146px;
  height: 34px;
  background-color: rgba(42, 130, 228, 1);
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  color: white;
  align-items: center;
  justify-content: center
}
</style>